import { useMemo } from 'react';

const useGetClassDate = (timestamp) => {
  const date = useMemo(() => {
    if (!timestamp) return null;
    const milliseconds = parseInt(timestamp, 10); // Parse timestamp as integer
    return new Date(milliseconds);
  }, [timestamp]);

  const parsedDate = useMemo(() => {
    if (!date) return { weekday: null, month: null, year: null };

    const weekday = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(date);
    const month = new Intl.DateTimeFormat('en-US', { month: '2-digit' }).format(date);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);

    return {
      weekday,
      month,
      year,
    };
  }, [date]);

  return parsedDate;
};

export default useGetClassDate;
